/**
 * Creates a `getVariant()` function that returns a style variant for a component.
 * @param {Object} baseStyles The base styles that are always applied to the component.
 * @param {Object} variants A map of style variants to choose from.
 * @returns {(variant: String)=> Object} A function to create a style variant for a component.
 *
 * @example
 *    makeVariant(
 *      { padding: 2 },
 *      {
 *        default: {},
 *        light: { color: 'white' },
 *        dark: { color: 'black' }
 *       }
 *     )
 */
export default function makeVariant(baseStyles, variants) {
  /**
   * Gets a component's style variant.
   * @param {String} variant The variant name.
   */
  return function(variant) {
    return {
      /* Any default styles here. */
      ...baseStyles,
      /* Variant values are added last. */
      ...(variants[variant] || variants.default),
    };
  };
}
